module Visonum.BulkPingApp.Components.App.Types
  ( Action(..)
  , DownloadFormat(..)
  , JobInputVals
  , LogInState(..)
  , State
  , parseInputVals
  ) where

import Prelude

import Data.Argonaut (jsonNull)
import Data.Argonaut as J
import Data.Codec.Argonaut as CA
import Data.Either (Either)
import Data.Generic.Rep (class Generic)
import Data.Maybe (Maybe, maybe)
import Data.Number as Number
import Data.Show.Generic (genericShow)
import Data.String (Pattern(..))
import Data.String as Str
import Foreign.Object (fromHomogeneous)
import Halogen.Query.HalogenM (ForkId)
import Visonum.API.SpeedMaster (BulkPingResultResponse, BulkPingStartRequest, BulkPingStatusResponse, UUIDv4, codecBulkPingStartRequest)
import Visonum.BulkPingApp.StaticConfig (StaticConfig)

data Action
  = Initialize
  | Finalize
  | ShowDetails UUIDv4
  | HideDetails
  | DownloadResults UUIDv4 DownloadFormat
  | UpdateJobInput JobInputVals
  | SetShowNewJob Boolean
  | SubmitNewJob
  | SetPassword String
  | CancelJob UUIDv4
  | HideError
  | Login
  | Logout

data DownloadFormat
  = DownloadCsv
  | DownloadJson

type JobInputVals =
  { agentUrl :: String
  , pingCountPerIp :: String
  , intervalBetweenIpsMillis :: String
  , intervalBetweenPingsMillis :: String
  , useIcmp :: Boolean
  , useSyn :: Boolean
  , synPort :: String
  , destinationIps :: String
  }

type State =
  { bulkPingStatus :: BulkPingStatusResponse
  , newJob :: JobInputVals
  , showNewJob :: Boolean
  , staticConfig :: StaticConfig
  , spmApiKey :: String
  , logInState :: LogInState
  , details ::
      Maybe
        { jobId :: UUIDv4
        , result :: Maybe (Either String BulkPingResultResponse)
        }
  , displayError ::
      Maybe
        { title :: String
        , message :: String
        }
  , pollingForkId :: Maybe ForkId
  }

data LogInState
  = LoginNotTried
  | LoginChecking
  | LoginSuccess
  | LoginFailure

derive instance Generic LogInState _

derive instance Eq LogInState

instance Show LogInState where
  show = genericShow

parseInputVals :: JobInputVals -> Either CA.JsonDecodeError BulkPingStartRequest
parseInputVals vals = do
  let
    obj = J.fromObject $ fromHomogeneous
      { destinationIps:
          J.fromArray (map J.fromString $ map Str.trim $ Str.split (Pattern "\n") $ Str.trim vals.destinationIps)
      , config: J.fromObject $ fromHomogeneous
          { agentUrl:
              J.fromString vals.agentUrl
          , pingCountPerIp:
              maybe J.jsonNull J.fromNumber (Number.fromString vals.pingCountPerIp)
          , intervalBetweenIpsMillis:
              maybe J.jsonNull J.fromNumber (Number.fromString vals.intervalBetweenIpsMillis)
          , intervalBetweenPingsMillis:
              maybe J.jsonNull J.fromNumber (Number.fromString vals.intervalBetweenPingsMillis)
          , useIcmp: J.fromBoolean vals.useIcmp
          , useSynToPort:
              if vals.useSyn then
                maybe J.jsonNull J.fromNumber (Number.fromString vals.synPort)
              else jsonNull
          }
      }

  CA.decode codecBulkPingStartRequest obj